import React, { useEffect } from 'react';
import SouthIcon from '@mui/icons-material/South';
import { Link } from 'react-router-dom';
export default function TransactionCard({ isAdmin, data }) {

  // Destructure the data object safely
  const { to, date,toEntity, transactionNo, bill } = data || {};

useEffect(()=>{
  console.log(data);
})


const formatDate = (seconds) => {
  if (!seconds) return "Invalid Date";
  return new Date(seconds * 1000).toLocaleString();
};

  return (
    <>
      {isAdmin ? (
        <div className="w-72 bg-white shadow-md rounded-xl p-4 border border-gray-200 m-3">
          <h1 className='flex items-center justify-center font-extrabold'>
            RedCat-Imagine
          </h1>
        </div>
      ) : (
        <>
          {/* Display flow direction with NorthIcon */}
          <div>
            <SouthIcon />
            <span className='font-light text-xs text-red-700'>
              {date ? formatDate(date) : "N/A"}
            </span>
          </div>

          {/* Display transaction details */}
          <div className="w-72 bg-white shadow-md rounded-xl p-4 border border-gray-200 m-3">
            <div className="space-y-2 text-xs">
              <p className="text-gray-700"><strong>Name:</strong>
              <Link to={`/new-user-details/${toEntity?.uid || "N/A"}`} style={{ textDecoration: "none", color: "blue", marginRight: "5px" }} >
               {toEntity?.name}
              </Link>
               </p>
             
              <p className="text-gray-700"><strong>Role:</strong> {toEntity?.role}</p>
              <p className="text-gray-700"><strong>City:</strong> {toEntity?.city}</p>
              <p className="text-gray-700"><strong>Transaction ID:</strong> {transactionNo}</p>
              {/* <p className="text-gray-700"><strong>Buying Amount:</strong>{bill || "N/A"}</p> */}
            </div>
          </div>
        </>
      )}
    </>
  );
}
